// ** React Imports
import { Link } from "react-router-dom";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Third Party Components
import {
  User,
  Settings,
  CreditCard,
  DollarSign,
  LogOut,
  LifeBuoy,
  MoreVertical // <-- Import adicionado
} from "react-feather";

// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";

import "src/@core/scss/base/components/user-drop-down.scss";

// ** Default Avatar Image
// import defaultAvatar from "@src/assets/images/portrait/small/avatar-s-11.jpg";
import {  useSelector } from "react-redux";
import { handleRevokeToken } from "../../../../redux/reducers/authUser";
import KeycloakService from "../../../../service/keycloak.js";
import { useDispatch } from "react-redux";
import { AuthUser } from "@src/@types/AuthUser";
import { RootState } from "@src/redux";
import { PlanType, Subscription, UserAccount } from "@src/@types/UserAccount";
import { titleCase } from "@src/utility/StringUtil";
import { useTranslation } from "react-i18next";
// import { sassVariables } from "@src/utility/variablesUtils";

interface UserDropdownProps {
  isExpanded?: boolean;
}

const UserDropdown = ({ isExpanded = true }: UserDropdownProps) => {
  const dispatch = useDispatch();
  const authUser:AuthUser = useSelector<RootState, AuthUser>((state) => state.authUser.authUser);
  const userAccount = useSelector<RootState, UserAccount>((state) => state.userAccount.userAccount);
  const fullName = userAccount.name || authUser.fullName;

  const subscription = useSelector<RootState, Subscription>(
    (state) => state.userAccount.subscription as Subscription
  );
  const { t } = useTranslation();

  const userPlan = subscription?.status === "TRIAL"
    ? t("navbar.userDropdown.trialPlan")
    : titleCase(subscription?.planName || t("navbar.userDropdown.defaultPlan") as string);

  const handleLogout = (event: any) => {
    event.preventDefault();
    dispatch(handleRevokeToken());
    KeycloakService.CallLogout("");
  };

  const capitalizeWords = (text: any) => {
    return text
      .toLowerCase()
      .split(' ')
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Agora faz um loop perfeito dentro do menu
  const handleMenuKeyDown = (e: any) => {
    if (e.key === 'Tab') {
      const menu = e.currentTarget;
      const focusableItems = Array.from(
        menu.querySelectorAll('a[href], button:not([disabled])')
      ) as HTMLElement[];
      
      const currentIndex = focusableItems.indexOf(document.activeElement as HTMLElement);

      e.preventDefault(); // <-- Impede o Tab natural de agir
      e.stopPropagation(); // <-- Impede o Reactstrap de fechar o menu

      if (!e.shiftKey) {
        // Tab indo pra frente
        // Se for o último, volta pro primeiro. Se não, vai pro próximo.
        const nextIndex = currentIndex === focusableItems.length - 1 ? 0 : currentIndex + 1;
        focusableItems[nextIndex].focus();
      } else {
        // Shift + Tab indo para trás
        // Se for o primeiro, vai pro último. Se não, vai pro anterior.
        const prevIndex = currentIndex === 0 ? focusableItems.length - 1 : currentIndex - 1;
        focusableItems[prevIndex].focus();
      }
    }
  };

  return (
    <UncontrolledDropdown tag="div" className="dropdown-user nav-item w-100">
      <DropdownToggle
        href="/"
        tag="a"
        className={`nav-link dropdown-user-link d-flex align-items-center w-100 ${isExpanded ? 'justify-content-between' : 'justify-content-center'}`}
        onClick={(e) => e.preventDefault()}
        title={fullName}
        data-toggle="dropdown"
      >
        {/* Agrupamento do Avatar e Textos para layout da base da barra lateral */}
        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
          <Avatar
            content={fullName }
            className='avatar-assistive'
            status="online"
            initials
          />
          {isExpanded && (
            <div className="d-flex flex-column text-start" style={{ margin: "4px 0 0 0" }}>
              <span className="user-name">
                {fullName}
              </span>
              <span className="user-plan text-muted">
                {userPlan}
              </span>
            </div>
          )}
        </div>

        {isExpanded && (
          <MoreVertical size={16} className="text-secondary " />
        )}

      </DropdownToggle>

      {/* ADICIONADO: onKeyDown={handleMenuKeyDown} intercepta as teclas dentro do menu */}
      <DropdownMenu 
          end 
          className={`w-100 ${isExpanded ? 'dropdownmenub' : 'dropdownmenusmall'}`} 
          style={!isExpanded ? { minWidth: 'auto' } : {}}
          onKeyDown={handleMenuKeyDown} 
      >         
        <DropdownItem tag={Link} to="/perfil" className={!isExpanded ? 'd-flex justify-content-center' : ''}>
          <User size={14} className={isExpanded ? 'me-75' : ''} />
          {isExpanded && (
            <span className="align-middle">{t("navbar.userDropdown.profile")}</span>
          )}
        </DropdownItem>
        
        {subscription?.planType !== PlanType.ENTERPRISE && (
          <DropdownItem tag={Link} to="/account-settings" className={!isExpanded ? 'd-flex justify-content-center' : ''}>
            <Settings size={14} className={isExpanded ? 'me-75' : ''} />
              {isExpanded && (
                <span className="align-middle">{t("navbar.userDropdown.account")}</span>
              )}
          </DropdownItem>
        )}

        {/* <DropdownItem tag={Link} to="/" onClick={(e) => e.preventDefault()}>
          <CreditCard size={14} className="me-75" />
          <span className="align-middle">Financeiro</span>
        </DropdownItem> */}
        {/* <DropdownItem
          tag={Link}
          to="/pages/"
          onClick={(e) => e.preventDefault()}
        >
          <LifeBuoy size={14} className="me-75" />
          <span className="align-middle">Central de ajuda</span>
        </DropdownItem> */}
        {/* <DropdownItem tag={Link} to="/" onClick={(e) => e.preventDefault()}>
          <DollarSign size={14} className="me-75" />
          <span className="align-middle">Planos</span>
        </DropdownItem> */}
        <DropdownItem divider />
        
        <DropdownItem
          tag={Link}
          onClick={(e) => {
            handleLogout(e);
          }}
          className={!isExpanded ? 'd-flex justify-content-center' : ''}
        >
          <LogOut size={14} className={isExpanded ? 'me-75' : ''} />
            {isExpanded && (  
              <span className="align-middle">{t("navbar.userDropdown.logout")}</span>
            )}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;